import React from "react";
import { Dialog, IconButton, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import { VERSION_DETAILS_URL } from "./versionDetails";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // 5% of breathing room on every side, so it reads as a dialog over the page
    paper: {
      display: "flex",
      flexDirection: "column",
      width: "90vw",
      height: "90vh",
      maxWidth: "none",
      maxHeight: "none",
      margin: 0,
      borderRadius: 10,
      overflow: "hidden"
    },
    bar: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      padding: theme.spacing(1, 1, 1, 2.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
      color: theme.palette.primary.main
    },
    title: {
      flex: 1,
      fontSize: 16,
      fontWeight: 600,
      color: theme.palette.text.primary
    },
    frame: {
      flex: 1,
      width: "100%",
      border: 0,
      display: "block"
    }
  })
);

interface VersionDetailsDialogProps {
  open: boolean;
  /** Shown in the bar and used as the iframe title */
  title: string;
  /** Route of the details page, without the "#" */
  hash: string;
  onClose: () => void;
}

/** Full-screen dialog that shows "Novidades em detalhe" on a version or an interval */
const VersionDetailsDialog: React.FC<VersionDetailsDialogProps> = ({ open, title, hash, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog maxWidth={false} open={open} onClose={onClose} classes={{ paper: classes.paper }} aria-labelledby="version-details-title">
      <div className={classes.bar}>
        <NewReleasesIcon />
        <Typography id="version-details-title" className={classes.title}>{title}</Typography>
        <IconButton aria-label="Fechar" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      {open && <iframe className={classes.frame} title={title} src={`${VERSION_DETAILS_URL}#${hash}`} />}
    </Dialog>
  );
};

export default VersionDetailsDialog;
